module.exports = __webpack_public_path__ + "img/24164fa.jpg";